import { get } from 'utils';
import en from 'locales/en.json';
import es from 'locales/es.json';
import { useLang } from './../Context/LanguageContext';

const useTranslation = () => {
  const lang = useLang(); // runtime URL-based language (replaces process.env.REACT_APP_LANG)

  const t = (path) => {
    const obj = { en, es };
    return get(obj[lang] || obj['en'], path, '');
  };

  return { t, lang };
};

export default useTranslation;